import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaCalculator, FaDollarSign, FaFileInvoiceDollar, FaChartLine } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";

const ServicesSection = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleNavigate = (section) => {
    navigate(`/services#${section}`);
  };

  const services = [
    {
      title: t("serviceSection.items.bookkeeping.title"),
      section: "bookkeeping",
      description: t("serviceSection.items.bookkeeping.description"),
      icon: <FaCalculator />,
      bgColor: "from-blue-50 to-white",
    },
    {
      title: t("serviceSection.items.payroll.title"),
      section: "payroll",
      description: t("serviceSection.items.payroll.description"),
      icon: <FaDollarSign />,
      bgColor: "from-green-50 to-white",
    },
    {
      title: t("serviceSection.items.taxes.title"),
      section: "taxes",
      description: t("serviceSection.items.taxes.description"),
      icon: <FaFileInvoiceDollar />,
      bgColor: "from-red-50 to-white",
    },
    {
      title: t("serviceSection.items.consulting.title"),
      section: "consulting",
      description: t("serviceSection.items.consulting.description"),
      icon: <FaChartLine />,
      bgColor: "from-yellow-50 to-white",
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="bg-white text-gray-900 py-24 text-center"
    >
      <h2 className="text-5xl font-bold text-yellow-600">{t("serviceSection.title")}</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-14 px-6 md:px-12 mt-12">
        {services.map((service, index) => (
          <motion.div
            key={service.section}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
            whileHover={{ scale: 1.07, boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)" }}
            onClick={() => handleNavigate(service.section)}
            className={`border border-gray-300 rounded-xl p-6 shadow-lg bg-gradient-to-br ${service.bgColor} transition-all duration-300 cursor-pointer`}
          >
            <motion.div
              whileHover={{ scale: 1.1 }}
              animate={{ y: [0, -5, 0] }}
              transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
              className="text-5xl text-yellow-600 mx-auto mb-4 flex justify-center"
            >
              {service.icon}
            </motion.div>

            <h3 className="text-3xl font-bold text-yellow-600">{service.title}</h3>
            <p className="text-xl text-gray-700 mt-4">{service.description}</p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default ServicesSection;
